export const Notifications = {
  INSTALLER: 1,
  STORE: 2,
  SMS: 3,
  EMAIL: 4,
  BACKENDMAPPING: {
    INSTALLER: 1,
    STORE: 3,
    CUSTOMER: 26,
  },
  CUSTOMER: 5,
  SUBTYPEMAPPING: {
    1: 'CLIENT',
    2: 'OPPORTUNITY',
    3: 'QUOTE',
    4: 'INVOICE',
    5: 'PAYMENT',
  },
  ACTION: {
    Review: 'review',
    Read: 'read',
  },
};
